export default __webpack_public_path__ + "static/media/pokeball.2c852aca.png";